import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { fetchOrder, type Order } from '../api'

export function Confirmation() {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('orderId')

  const [order, setOrder] = useState<Order | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!orderId) { setLoading(false); setError(true); return }
    let cancelled = false
    let attempt = 0
    const tryFetch = () => {
      fetchOrder(orderId)
        .then(o => {
          if (cancelled) return
          if (o) { setOrder(o); setLoading(false) }
          else if (attempt < 4) { attempt++; setTimeout(tryFetch, 2000) }
          else { setError(true); setLoading(false) }
        })
        .catch(() => { if (!cancelled) { setError(true); setLoading(false) } })
    }
    tryFetch()
    return () => { cancelled = true }
  }, [orderId])

  if (loading) return <p className="state-loading container">Laster inn...</p>

  if (error || !order) {
    return (
      <div className="state-empty container">
        <p>Ordre ikke funnet.</p>
        <Link to="/" style={{ display: 'inline-block', marginTop: '1rem', textDecoration: 'underline' }}>
          ← Tilbake til galleriet
        </Link>
      </div>
    )
  }

  const totalNok = order.priceNok + order.shippingNok

  return (
    <main className="confirmation container">
      <title>Kjøpsbekreftelse — Originalene</title>
      <meta name="robots" content="noindex" />
      <div className="confirmation-check">✓</div>
      <h1 className="confirmation-title">Takk, {order.buyerName}!</h1>
      <p className="confirmation-subtitle">Ditt kjøp er bekreftet.</p>

      <div className="confirmation-card">
        <img
          src={order.artworkImageUrl}
          alt={order.artworkTitle}
          className="confirmation-img"
        />
        <p className="confirmation-artwork-title">{order.artworkTitle}</p>
        <div className="confirmation-price-breakdown">
          <span>{order.priceNok.toLocaleString('nb-NO')} NOK</span>
          {order.shippingNok > 0 && (
            <span style={{ color: 'var(--muted)', fontSize: '0.875rem' }}>
              + {order.shippingNok.toLocaleString('nb-NO')} NOK frakt
            </span>
          )}
          {order.shippingNok > 0 && (
            <span style={{ fontWeight: 700 }}>
              Totalt: {totalNok.toLocaleString('nb-NO')} NOK
            </span>
          )}
        </div>
        <div style={{ fontSize: '0.875rem', color: 'var(--muted)', textAlign: 'center', lineHeight: 1.7 }}>
          {order.shippingMethod === 'pickup' ? (
            <div>📍 Hentes{order.buyerAddress ? ` — ${order.buyerAddress}` : ''}</div>
          ) : (
            <div>
              {order.buyerAddress
                ? `🚚 Sendes til: ${order.buyerAddress}`
                : '🚚 Sendes — leveringsadresse registrert'}
            </div>
          )}
          {order.artistPhone && (
            <div style={{ marginTop: '0.5rem' }}>
              Kontakt kunstner:{' '}
              <a href={`tel:${order.artistPhone}`} style={{ color: '#111', fontWeight: 600 }}>
                {order.artistPhone}
              </a>
            </div>
          )}
        </div>
      </div>

      <Link to="/" className="btn-buy" style={{ display: 'inline-block', maxWidth: '220px' }}>
        ← Tilbake til galleriet
      </Link>
    </main>
  )
}
